import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Grade create / edit modal — same form, one component. Modal-state pattern:
 * `initialValues` + Form `key` per target + `destroyOnHidden`, no
 * setFieldsValue-in-useEffect (that races Form mount under destroyOnHidden).
 */
import React, { useState } from 'react';
import { Form, Input, InputNumber, Modal } from 'antd';
import { createGrade, updateGrade } from '../../api';
import { notifySuccess } from '../errors';
export function GradeModal({ open, onClose, onDone, initial }) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const initialValues = initial ? { name: initial.name, price: initial.price } : { price: 0 };
    const formKey = initial ? `edit-${initial.id}` : 'create';
    const submit = async () => {
        let v;
        try {
            v = await form.validateFields();
        }
        catch {
            return;
        }
        setSubmitting(true);
        try {
            if (initial) {
                await updateGrade(initial.id, { name: v.name.trim(), price: Number(v.price) || 0 });
                notifySuccess('הכיתה עודכנה');
            }
            else {
                await createGrade({ name: v.name.trim(), price: Number(v.price) || 0 });
                notifySuccess('כיתה נוצרה');
            }
            onDone();
        }
        catch { /* client auto-surfaces */ }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx(Modal, { title: initial ? 'עריכת כיתה' : 'יצירת כיתה', open: open, onCancel: onClose, onOk: submit, okText: initial ? 'שמור' : 'צור', cancelText: "\u05D1\u05D8\u05DC", confirmLoading: submitting, destroyOnHidden: true, children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, initialValues: initialValues, children: [_jsx(Form.Item, { name: "name", label: "\u05E9\u05DD \u05D4\u05DB\u05D9\u05EA\u05D4", rules: [{ required: true, message: 'שם נדרש' }], children: _jsx(Input, { placeholder: "\u05DC\u05DE\u05E9\u05DC: \u05DB\u05D9\u05EA\u05D4 \u05D8\u05F3" }) }), _jsx(Form.Item, { name: "price", label: "\u05DE\u05D7\u05D9\u05E8 (\u20AA)", children: _jsx(InputNumber, { min: 0, style: { width: '100%' } }) })] }, formKey) }));
}
